import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import i18next from "i18next";
import HelpIcon from "@material-ui/icons/Help";
import React from "react";

function LabelHint(props) {
  const { title, hint } = props;

  function SimpleDialog(props) {
    const { onClose, hint, open } = props;

    const handleClose = () => {
      onClose();
    };

    return (
      <Dialog onClose={handleClose} open={open}>
        {/* Центрирование текста подсказки — пункт 72 QA-таблицы. */}
        <DialogTitle
          sx={{ textAlign: "center" }}
          dangerouslySetInnerHTML={{ __html: i18next.t(hint) }}
        ></DialogTitle>
      </Dialog>
    );
  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <>
      {/* minWidth: 0 на обоих уровнях — иначе flex-элемент не сжимается ниже
          ширины текста, и на узком экране подпись вылезает за край вместе с «?». */}
      <div style={{ flexDirection: "row", display: "flex", minWidth: 0 }}>
        <div style={{ marginTop: 10, minWidth: 0 }}>
          <label
            htmlFor="area1"
            className="form__label"
            title={i18next.t(hint)}
          >
            {i18next.t(props.title)}
          </label>
        </div>
        <div style={{ marginTop: 6, flexShrink: 0 }}>
          <HelpIcon onClick={handleClickOpen} style={{ marginLeft: 4 }} />
        </div>
      </div>

      <SimpleDialog
        open={open}
        onClose={handleClose}
        hint={hint ?? "hint text"}
      />
    </>
  );
}

export default LabelHint;
